module.exports = __webpack_public_path__ + "fonts/9c35bf8.otf";